/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerStreamContentQueryResponse, TrimbleItemsControllerStreamContentQueryParams } from "../../models/trimbleController/TrimbleItemsControllerStreamContent";

function getTrimbleItemsControllerStreamContentUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble/content` as const }  
  return res
}

/**
 * @summary Stream the bytes of a Trimble file
 * {@link /api/v1/trimble/content}
 */
export async function trimbleItemsControllerStreamContent(params: TrimbleItemsControllerStreamContentQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerStreamContentQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTrimbleItemsControllerStreamContentUrl().url.toString(), params, ... requestConfig })  
  return res.data
}